
/* eslint-disable camelcase */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { getBranchRecord, getRecordList, cycleCheckList, exportRecord } from '../../api/cyclCheck';
import { parseTime } from '../../utils';
import DialogSelecedtName from './components/BranchDialog.vue';
import DialogImgLarge from '@/components/ImgLarge/index.vue';

const stateOptions = [{
  value: '0',
  label: '未点检'
}, {
  value: '1',
  label: '正常'
}, {
  value: '2',
  label: '异常'
}, {
  value: '9',
  label: '已点检'
}];

@Component({
  name: 'BranchOrderServicer',
  filters: {
    formatDate(val: string) {
      if (val === '' || parseInt(val) === 0) {
        return '';
      }
      return parseTime(parseInt(val), '{y}-{m}-{d}');
    },
    fromatState(val: string) {
      let detail = '';
      switch (parseInt(val)) {
        case 0:
          detail = '未点检';
          break;
        case 1:
          detail = '正常';
          break;
        case 2:
          detail = '异常';
          break;
      }
      return detail;
    }
  },
  components: {
    DialogSelecedtName,
    DialogImgLarge
  }
})
export default class extends Vue {
  private formSearch:any = {
    name: '',
    isBranch: '',
    event: '',
    startTime: '',
    endTime: '',
    state: '',
    page: 1,
    size: 10
  }
  private listQuery = {
    total: 0,
    page: 1,
    size: 10
  }
  private eventOptions = []
  private selecedtNameVisible = false
  private selectedNameReadonly = false

  @Watch('selecedtNameVisible', {
    immediate: true
  })toggleVisible(val: boolean) {
    if (val) {
      this.selectedNameReadonly = true;
    } else {
      this.selectedNameReadonly = false;
    }
  }
  private clearCompany() {
    this.checkboxDisabled = true;
  }
  private selectedNameHandle() {
    this.selecedtNameVisible = true;
  }
  private selectBranch(branch:any) {
    this.checkboxDisabled = false;
    this.formSearch.name = branch.name;
    this.formSearch.branchCompanyId = branch.id;
    this.selecedtNameVisible = false;
  }
  private selecedtNameClose(val: boolean) {
    this.selecedtNameVisible = val;
  }
  private checkboxDisabled=false;
  created() {
    this.getCheckList(UserModule.getCompanyId);
    if (Object.keys(this.$route.query).length !== 0) {
      let pamars:any = JSON.parse(this.$route.query.pamars.toString());
      let isBranch = pamars.containBranch;
      this.checkboxDisabled = pamars.checkboxDisabled;
      let state = pamars.last_check_state.toString();
      let startTime = '';
      let endTime = '';
      if (pamars.startTime) {
        startTime = pamars.startTime + '000';
      } else {
        let dataStr = new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getDate() + ' 00:00';
        startTime = new Date(dataStr).getTime().toString();
      }
      if (pamars.endTime) {
        endTime = pamars.endTime + '000';
      } else {
        let data = new Date();
        endTime = new Date().getTime().toString();
      }
      this.formSearch.isBranch = isBranch;
      this.formSearch.state = state;
      this.formSearch.startTime = startTime;
      this.formSearch.endTime = endTime;
      if (pamars.branchCompanyId) {
        this.formSearch.name = pamars.name;
        this.formSearch.branchCompanyId = pamars.branchCompanyId;
      }
      if (pamars.event) {
        // this.formSearch.event = pamars.event;
        this.$set(this.formSearch, 'event', pamars.event);
      }
      this.handleSearch();
    } else {
      this.getBranchRecord();
    }
  }
  private companyLev=1;
  private stateOptions = stateOptions
  private handleSearch() {
    this.getBranchRecord();
  }
  private handleClear() {
    this.checkboxDisabled = true;
    this.formSearch = {
      branch_company_id: '',
      isBranch: '',
      event: '',
      startTime: '',
      endTime: '',
      state: ''
    };
    this.getBranchRecord();
  }
  private handleSizeChange(val:number) {
    this.listQuery.size = val;
    this.getBranchRecord();
  }
  private handleCurrentChange(val:number) {
    this.listQuery.page = val;
    this.getBranchRecord();
  }
  private listLoading = false;
  private orderList = [];
  private getBranchRecord() {
    this.listLoading = true;
    const params = {
      branch_company_id: this.formSearch.branchCompanyId,
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      contain_branch: this.checkboxDisabled ? '1' : this.formSearch.isBranch ? '1' : '0',
      cycle_check_id: this.formSearch.event ? parseInt(this.formSearch.event.sync_id) !== 0 ? this.formSearch.event.sync_id : this.formSearch.event.id : '',
      start_time: this.formSearch.startTime ? this.formSearch.startTime.toString().substring(0, 10) : '',
      end_time: this.formSearch.endTime ? this.formSearch.endTime.toString().substring(0, 10) : '',
      last_check_state: this.formSearch.state,
      page: this.listQuery.page,
      size: this.listQuery.size,
      is_info: 1
    };
    this.orderList = [];
    getBranchRecord(params).then(res => {
      this.listLoading = false;
      if (res && res.data) {
        this.orderList = res.data.list;
        this.listQuery.total = res.data.count || 0;
        this.listQuery.page = res.data.page_current;
        this.listQuery.size = res.data.page_size;
        this.companyLev = res.data.company_level;
      } else {
        this.orderList = [];
      }
    }).catch(err => {
      this.listQuery.total = 0;
      this.listQuery.page = 1;
      this.listQuery.size = 10;
      this.listLoading = false;
      let msg = err.msg;
      // this.showErrorMsg(err.msg);
    });
  }
  // 导出Excel
  handleExport() {
    let params = {
      branch_company_id: this.formSearch.branchCompanyId,
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName,
      contain_branch: this.formSearch.isBranch ? '1' : '0',
      cycle_check_id: this.formSearch.event ? parseInt(this.formSearch.event.sync_id) !== 0 ? this.formSearch.event.sync_id : this.formSearch.event.id : '',
      start_time: this.formSearch.startTime ? this.formSearch.startTime.toString().substring(0, 10) : '',
      end_time: this.formSearch.endTime ? this.formSearch.endTime.toString().substring(0, 10) : '',
      last_check_state: this.formSearch.state,
      page: this.listQuery.page,
      size: this.listQuery.size
    };
    exportRecord(params).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private checkDetailVisible = false
  private activeDetailName = 'first'
  private checkDetailData = []
  private hasMoreDetail = false
  private detailCurrentPage = 1
  private currentDetailRow:any = {};
  private moreDetail() {
    this.hasMoreDetail = true;
    this.detailCurrentPage += 1;
    this.getDetailList();
  }
  // 获取事件列表
  private getCheckList(companyId:any) {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = companyId;
    cycleCheckList(params).then(res => {
      if (res.data != null && res.data.list && res.data.list.length > 0) {
        this.eventOptions = res.data.list;
      } else {
        this.eventOptions = [];
      }
    }).catch(err => {
      this.eventOptions = [];
      let msg = err.msg;
    });
  }
  private getDetailList() {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      branch_company_id: this.currentDetailRow.company_id,
      // check_name: this.currentDetailRow.name,
      // start_time: this.currentDetailRow.check_start_time,
      // end_time: this.currentDetailRow.check_end_time,
      job_id: this.currentDetailRow.id,
      // state_value: this.currentDetalRow.last_check_state
      page: this.detailCurrentPage,
      size: 10
    };
    getRecordList(params).then(res => {
      if (res.data === null || (res.data && res.data.page_count <= this.detailCurrentPage)) {
        this.hasMoreDetail = false;
      } else {
        this.hasMoreDetail = true;
      }
      if (res && res.data) {
        if (this.detailCurrentPage === 1) {
          this.checkDetailData = res.data.list;
        } else {
          this.checkDetailData = this.checkDetailData.concat(res.data.list);
        }
      } else {
        this.checkDetailData = [];
      }
    }).catch(err => {
      let msg = err.msg;
      // this.showErrorMsg(err.msg);
    });
  }
  private detailHandle(val: any) {
    this.checkDetailVisible = true;
    this.currentDetailRow = val;
    this.detailCurrentPage = 1;
    this.getDetailList();
  }
  private checkDetailClose() {
    this.checkDetailData = [];
    this.checkDetailVisible = false;
  }
  private handleMedia(val: any, index: number, type: any) {
    let arr = [];
    if (type === 2 && val) {
      let h: any = {};
      h.media_type = type;
      h.video_url = val;
      arr.push(h);
    } else {
      arr = val;
    }
    let enlargedData = {
      isShow: true,
      imgList: arr,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
